import axios from "axios";

import { authIsMissing } from "./auth";

export const FETCH_DATA = "CONSENT_MIRRORING/FETCH_DATA";
export const FETCH_DATA_SUCCESS = "CONSENT_MIRRORING/FETCH_DATA_SUCCESS";
export const FETCH_DATA_FAILED = "CONSENT_MIRRORING/FETCH_DATA_FAILED";

export const SAVE_ENTRY = "CONSENT_MIRRORING/SAVE_ENTRY";
export const SAVE_ENTRY_FAILED = "CONSENT_MIRRORING/SAVE_ENTRY_FAILED";
export const SAVE_ENTRY_SUCCESS = "CONSENT_MIRRORING/SAVE_ENTRY_FAILED_SUCCESS";

export const CLOSE_SAVE_MODAL = "CONSENT_MIRRORING/CLOSE_SAVE_MODAL";
export const CLOSE_DELETE_CONFIRM_MODAL = "CONSENT_MIRRORING/CLOSE_DELETE_CONFIRM_MODAL";
export const CLEAR_SAVE_ERROR = "CONSENT_MIRRORING/CLEAR_SAVE_ERROR";

export const DELETE_RECORD = "CONSENT_MIRRORING/DELETE_RECORD";

export const DELETE_RECORD_SUCCESS = "CONSENT_MIRRORING/DELETE_RECORD_SUCCESS";
export const DELETE_RECORD_FAILED = "CONSENT_MIRRORING/DELETE_RECORD_FAILED";
export const CLEAR_DELETE_ERROR = "CONSENT_MIRRORING/CLEAR_DELETE_ERROR";
export const CLEAR_ERRORS = "CONSENT_MIRRORING/CLEAR_ERRORS";

const initialState = {
  loading: false,
  data: [],
  error: null,
  pages: -1,
  saveError: null,
  saving: false,
  deleting: false,
  deleteError: null,
};

export const fetchData = (dispatch) => (
  page,
  pageSize,
  domain
) => {
  dispatch({
    type: FETCH_DATA,
  });

  const accessToken = sessionStorage.getItem("accessToken");
  if (
    accessToken === null ||
    accessToken === "" ||
    accessToken === "undefined"
  ) {
    sessionStorage.removeItem("accessToken");
    return dispatch(authIsMissing());
  }
  let params = {
    page,
    pageSize,
  };

  if (!!domain && domain !== -1) {
    params["domainId"] = domain;
  }

  return axios
    .get(`${process.env.REACT_APP_API_HOST}/consent/mirroring`, {
      params,
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    })
    .then((res) => {
      const auditDate = res.data.data.results.map((row, idx) => {
        return { ...row, rowIndex: idx };
      });
      return dispatch({
        type: FETCH_DATA_SUCCESS,
        data: auditDate,
        pages: res.data.data.pageCount,
        pageSize: res.data.data.pageSize,
      });
    })
    .catch((err) => {
      if (
        err !== undefined &&
        err.response !== undefined &&
        err.response.status === 401
      ) {
        // lets authenticate again
        sessionStorage.removeItem("accessToken");
        return dispatch(authIsMissing());
      }
      return dispatch({
        type: FETCH_DATA_FAILED,
        error: err,
      });
    });
};

export const saveEntry = (dispatch) => (data) => {
  dispatch({
    type: SAVE_ENTRY,
  });

  const accessToken = sessionStorage.getItem("accessToken");

  if (
    accessToken === null ||
    accessToken === "" ||
    accessToken === "undefined"
  ) {
    sessionStorage.removeItem("accessToken");
    return dispatch(authIsMissing());
  }

  return axios({
    method: "post",
    url: `${process.env.REACT_APP_API_HOST}/consent/mirroring-create`,
    data,
    headers: {
      Authorization: `Bearer ${accessToken}`,
      "Content-Type": "multipart/form-data",
    },
  })
    .then((res) => {
      return dispatch({
        type: SAVE_ENTRY_SUCCESS,
      });
    })
    .catch((err) => {
      if (
        err !== undefined &&
        err.response !== undefined &&
        err.response.status === 401
      ) {
        // lets authenticate again
        sessionStorage.removeItem("accessToken");
        return dispatch(authIsMissing());
      }
      return dispatch({
        type: SAVE_ENTRY_FAILED,
        error: err,
      });
    });
};

export const deleteEntry = (dispatch) => (dataID) => {
  dispatch({
    type: DELETE_RECORD,
  });

  const accessToken = sessionStorage.getItem("accessToken");
  if (
    accessToken === null ||
    accessToken === "" ||
    accessToken === "undefined"
  ) {
    sessionStorage.removeItem("accessToken");
    return dispatch(authIsMissing());
  }

  let bodyFormData = new FormData();
  bodyFormData.set("id", dataID);

  return axios({
    method: "post",
    url: `${process.env.REACT_APP_API_HOST}/consent/mirroring-remove`,
    data: bodyFormData,
    headers: {
      Authorization: `Bearer ${accessToken}`,
      "Content-Type": "multipart/form-data",
    },
  })
    .then((res) => {
      return dispatch({
        type: DELETE_RECORD_SUCCESS,
      });
    })
    .catch((err) => {
      if (
        err !== undefined &&
        err.response !== undefined &&
        err.response.status === 401
      ) {
        // lets authenticate again
        sessionStorage.removeItem("accessToken");
        return dispatch(authIsMissing());
      }
      return dispatch({
        type: DELETE_RECORD_FAILED,
        error: err,
      });
    });
};


export const clearDeleteError = () => {
  return {
    type: CLEAR_DELETE_ERROR,
  };
};

export const clearSaveError = () => {
  return {
    type: CLEAR_SAVE_ERROR,
  };
};

export const clearErrors = () => {
  return {
    type: CLEAR_ERRORS,
  };
};

export default (state = initialState, action) => {
  switch (action.type) {
    case CLEAR_ERRORS:
      return {
        ...state,
        error: null,
        saveError: null,
        deleteError: null,
      }; 
    case FETCH_DATA:
      return {
        ...state,
        loading: true,
        data: [],
        error: null,
      };
    case FETCH_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.data,
        pages: action.pages,
        error: null,
      };
    case FETCH_DATA_FAILED:
      return {
        ...state,
        loading: false,
        data: [],
        error: action.error,
      };

    case SAVE_ENTRY:
      return {
        ...state,
        saving: true,
        saveError: null,
      };

    case SAVE_ENTRY_SUCCESS:
      return {
        ...state,
        saving: false,
        saveError: null,
      };

    case SAVE_ENTRY_FAILED:
      return {
        ...state,
        saving: false,
        saveError: action.error,
      };

    case CLEAR_SAVE_ERROR:
      return {
        ...state,
        saveError: null,
      };

    case DELETE_RECORD:
      return {
        ...state,
        deleting: true,
      };

    case DELETE_RECORD_SUCCESS:
      return {
        ...state,
        deleting: false,
        deleteError: null,
      };

    case DELETE_RECORD_FAILED:
      return {
        ...state,
        deleting: false,
        deleteError: action.error,
      };

    case CLEAR_DELETE_ERROR:
      return {
        ...state,
        deleteError: null,
      };

    default:
      return state;
  }
};
